document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.partner-logos__carousel');
  if (!container) return;
  const track = container.querySelector('.partner-logos__carousel-track');
  const items = Array.from(track.children);

  const GAP = 10;
  let itemsPerView = 6;
  let current = 0;
  let interval = null;

  function updateItemsPerView() {
    const w = window.innerWidth;
    if (w <= 550) itemsPerView = 2;
    else if (w <= 768) itemsPerView = 3;
    else if (w <= 1024) itemsPerView = 4;
    else if (w <= 1280) itemsPerView = 5;
    else itemsPerView = 6;
  }

  function updateCarousel() {
    const cardWidth = items[0].offsetWidth;
    track.style.transform = 'translateX(-' + current * (cardWidth + GAP) + 'px)';
  }

  function next() {
    current++;
    if (current > items.length - itemsPerView) {
      current = 0;
    }
    updateCarousel();
  }

  function startAuto() {
    if (interval) clearInterval(interval);
    interval = setInterval(next, 2500);
  }

  function onResize() {
    updateItemsPerView();
    current = 0;
    updateCarousel();
  }

  updateItemsPerView();
  updateCarousel();
  window.addEventListener('resize', onResize);
  startAuto();
});
